export default "__VITE_ASSET__CLgbMDrK__"